import { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect'

const useInterval = (callback, delay) => {
  const savedCallback = useRef(callback)
  const intervalRef = useRef()

  /* Remember the latest callback if it changes. */
  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const tick = () => {
      savedCallback.current()
    }
    if (delay !== null) {
      intervalRef.current = setInterval(tick, delay)
    }

    const id = intervalRef.current

    return () => {
      clearInterval(id)
    }
  }, [delay])

  /* handle unmounted */
  useEffect(() => {
    const id = intervalRef.current
    return () => {
      clearInterval(id)
    }
  }, [])

  const resetInterval = useCallback(() => {
    clearInterval(intervalRef.current)
    intervalRef.current = setInterval(savedCallback.current, delay)
  }, [delay])

  return resetInterval
}

useInterval.defaultProps = {
  callback: () => {},
  delay: null,
}

useInterval.propTypes = {
  callback: PropTypes.func,
  delay: PropTypes.number,
}

export default useInterval
